@if (sdkInitalized) {
  <div class="onfido-container">
    <div id="onfidoContainer"></div>
  </div>
} @else if (displayCheckEmailError) {
  <div class="error-container">
    <h2>{{ 'REGISTRATION.ONFIDO_EMBEDDED.TITLE' | translate }}</h2>
    <p>{{ 'REGISTRATION.ONFIDO_EMBEDDED.ERROR' | translate }}</p>
  </div>
}
